module.exports = __webpack_public_path__ + "img/slide1_long.db0ea178.png";